import { render, staticRenderFns } from "./dialogEditPersonnelInfo.vue?vue&type=template&id=28c12472&"
import script from "./dialogEditPersonnelInfo.vue?vue&type=script&lang=js&"
export * from "./dialogEditPersonnelInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogEditPersonnelInfo.vue?vue&type=style&index=0&id=28c12472&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports